module.exports = __webpack_public_path__ + "img/cliff-entrance.6b940696.png";